var map = {
	"./Arrow-left.png": 13784,
	"./Arrow-right-on.png": 27915,
	"./Arrow-right.png": 1229,
	"./Arrow.png": 55428,
	"./Capa_1.png": 27514,
	"./Group.png": 22470,
	"./Header1.png": 44955,
	"./Header2.png": 82976,
	"./MORE+.png": 29669,
	"./MORE.png": 90060,
	"./MORE2+.png": 69437,
	"./MORE3+.png": 8986,
	"./MOREss.png": 92418,
	"./Polygon 1.png": 24468,
	"./bogu_logo.png": 23070,
	"./brain-sec03__backgroundtext1.png": 70294,
	"./brain-sec03__backgroundtext2.png": 51917,
	"./brain-sec03__backgroundtext3.png": 11972,
	"./brain-sec03__backgroundtext4.png": 93627,
	"./chetbot-back.png": 23548,
	"./chetbot-back2.png": 53300,
	"./chetbot-back3.png": 96810,
	"./chetbot.gif": 89229,
	"./chetbot2.gif": 33789,
	"./futter.png": 42221,
	"./house.gif": 97968,
	"./main-popup--title--blood_txt.png": 82062,
	"./main-popup--title--brain_txt.png": 93978,
	"./main-popup--title.png": 86365,
	"./main-popup--title_txt.png": 58044,
	"./main-popup-swiper__button01.svg": 70503,
	"./main-popup-swiper__button02.svg": 5940,
	"./main-popup01.png": 61392,
	"./main-popup02.png": 43147,
	"./main-popup03.png": 79490,
	"./main-visual__img01.png": 29509,
	"./main-visual__img02.png": 10734,
	"./main-visual__img03.png": 84375,
	"./main-visual__img04.png": 21112,
	"./main-visual__img05.png": 93825,
	"./main-visual__img06.jpg": 97070,
	"./main-visual__img06.png": 44842,
	"./main-visual__img07.png": 95603,
	"./main_scroll.png": 1802,
	"./map-brain-mo.png": 82881,
	"./map-brain-pc.png": 32566,
	"./map-mom-mo.png": 53050,
	"./map-mom-pc.png": 2973,
	"./map_1F_maingate.jpg": 96118,
	"./map_1F_maingate_ar.png": 88246,
	"./map_1F_maingate_ar02.png": 36844,
	"./map_1F_maingate_en.png": 19494,
	"./map_1F_maingate_en02.png": 80348,
	"./map_1F_maingate_mn.png": 8046,
	"./map_1F_maingate_mn02.png": 3652,
	"./map_1F_maingate_ru.png": 2308,
	"./map_1F_maingate_ru02.png": 25390,
	"./map_1F_maingate_zh.png": 49961,
	"./map_1F_maingate_zh02.png": 96811,
	"./map_1F_northgate.jpg": 47490,
	"./map_1F_northgate02.jpg": 13688,
	"./map_1F_northgate_ar.png": 69738,
	"./map_1F_northgate_ar02.png": 64992,
	"./map_1F_northgate_en.png": 69338,
	"./map_1F_northgate_en02.png": 79920,
	"./map_1F_northgate_mn.png": 8098,
	"./map_1F_northgate_mn02.png": 52984,
	"./map_1F_northgate_ru.png": 27680,
	"./map_1F_northgate_ru02.png": 85194,
	"./map_1F_northgate_zh.png": 2221,
	"./map_1F_northgate_zh02.png": 18735,
	"./map_3F.jpg": 91721,
	"./map_3F_ar.png": 36215,
	"./map_3F_ar02.png": 45509,
	"./map_3F_en.png": 37743,
	"./map_3F_en02.png": 8317,
	"./map_3F_mn.png": 70567,
	"./map_3F_mn02.png": 15061,
	"./map_3F_ru.png": 46845,
	"./map_3F_ru02.png": 21599,
	"./map_3F_zh.png": 93248,
	"./map_3F_zh02.png": 75946,
	"./map_B1.jpg": 62805,
	"./map_B1_ar.png": 77099,
	"./map_B1_ar02.png": 96665,
	"./map_B1_en.png": 52307,
	"./map_B1_en02.png": 57441,
	"./map_B1_mn.png": 49499,
	"./map_B1_mn02.png": 8585,
	"./map_B1_ru.png": 81401,
	"./map_B1_ru02.png": 31931,
	"./map_B1_zh.png": 23924,
	"./map_B1_zh02.png": 55710,
	"./map_parkingGarage.jpg": 11199,
	"./map_parkingGarage_ar.png": 56041,
	"./map_parkingGarage_ar02.png": 9611,
	"./map_parkingGarage_en.png": 10985,
	"./map_parkingGarage_en02.png": 6699,
	"./map_parkingGarage_mn.png": 99873,
	"./map_parkingGarage_mn02.png": 89411,
	"./map_parkingGarage_ru.png": 22759,
	"./map_parkingGarage_ru02.png": 10101,
	"./map_parkingGarage_zh.png": 95802,
	"./map_parkingGarage_zh02.png": 4464,
	"./news_img.png": 35674,
	"./plus.png": 27071,
	"./popup-chetbot-arrow-brain.svg": 58204,
	"./popup-chetbot-arrow-mom.svg": 69629,
	"./popup-chetbot-arrow.svg": 4503,
	"./popup-chetbot-test.png": 28442,
	"./puple_more.png": 72953,
	"./quick_arrow.png": 74556,
	"./quick_icon01.png": 88645,
	"./quick_icon01_hover.png": 29462,
	"./quick_icon02.png": 60814,
	"./quick_icon02_hover.png": 29413,
	"./quick_icon03.png": 60311,
	"./quick_icon03_hover.png": 40360,
	"./quick_icon04.png": 38168,
	"./quick_icon04_hover.png": 84423,
	"./quick_icon05.png": 59297,
	"./quick_icon05_hover.png": 89234,
	"./quick_icon06.png": 1866,
	"./quick_icon06_hover.png": 25937,
	"./quick_icon07.png": 33779,
	"./quick_icon07_hover.png": 32308,
	"./quick_icon08.png": 7860,
	"./quick_icon08_hover.png": 28931,
	"./quick_icon09.png": 28989,
	"./quick_icon09_hover.png": 88734,
	"./sec01_visual01.jpg": 3495,
	"./sec01_visual02.jpg": 66040,
	"./sec01_visual03.png": 52933,
	"./sec01_visual04.png": 82506,
	"./sec01_visual05.png": 14419,
	"./section01_Vector.png": 45357,
	"./section01_circle.png": 62472,
	"./section01_gg01.png": 57499,
	"./section01_gg02.png": 59936,
	"./section01_gg03.png": 84137,
	"./section01_sub-main.jpg": 8320,
	"./section02-swiper-button-next.png": 33382,
	"./section02-swiper-button-next02.png": 42300,
	"./section02-swiper-button-next2.png": 51366,
	"./section02-swiper-button-prev.png": 22950,
	"./section02-swiper-button-prev02.png": 42588,
	"./section02-swiper-button-prev2.png": 97702,
	"./section02__background-ball.png": 98522,
	"./section02__background-ball2.png": 53938,
	"./section02__background-ball3.png": 68763,
	"./section02__backgroundtext1.png": 35550,
	"./section02__backgroundtext2.png": 2901,
	"./section02__backgroundtext3.png": 33804,
	"./section02__backgroundtext4.png": 63971,
	"./section02__list--item.png": 61493,
	"./section02__list1.jpg": 93797,
	"./section02__list1.png": 37269,
	"./section02__list2.jpg": 36570,
	"./section02__list2.png": 542,
	"./section02__list3.jpg": 4855,
	"./section02__list3.png": 76327,
	"./section02__list4.jpg": 28268,
	"./section02__list4.png": 96712,
	"./section02__list5.jpg": 42409,
	"./section02__list5.png": 45105,
	"./section02__list6.png": 68858,
	"./section03-back1.jpg": 43736,
	"./section03-back1.png": 60540,
	"./section03-back2.jpg": 23719,
	"./section03-back3.jpg": 72330,
	"./section03-back4.jpg": 92697,
	"./section03-back4.png": 90785,
	"./section03-back5.jpg": 22172,
	"./section03.png": 25113,
	"./section03_1-back.jpg": 70697,
	"./section03_1-back.png": 73393,
	"./section03_1.jpg": 37521,
	"./section03_1.png": 99065,
	"./section03_2-back.jpg": 77332,
	"./section03_2-back.png": 29552,
	"./section03_2.jpg": 21670,
	"./section03_2.png": 42978,
	"./section03_3-back.jpg": 56819,
	"./section03_3-back.png": 34203,
	"./section03_3.jpg": 95427,
	"./section03_3.png": 64107,
	"./section03_4-back.jpg": 94830,
	"./section03_4-back.png": 42602,
	"./section03_4.jpg": 76624,
	"./section03_4.png": 14196,
	"./section03_5-back.jpg": 78933,
	"./section03_5-back.png": 74309,
	"./section03_5.jpg": 21517,
	"./section03_5.png": 47229,
	"./section03__backgroundtext1.png": 86773,
	"./section03__backgroundtext2.png": 1022,
	"./section03__list.jpg": 84991,
	"./section03__list2.png": 20557,
	"./section05_list--box.jpg": 33179,
	"./section05_list--box2.jpg": 913,
	"./section07_list--box.jpg": 93201,
	"./section07_list--box.png": 63801,
	"./section07_list--box2.jpg": 65823,
	"./section07_list--box2.png": 93103,
	"./view_arrow_r.png": 30837,
	"./viewmore.png": 85411,
	"./visual-main__button-list1.png": 52661,
	"./visual-main__button-list2.png": 66910,
	"./visual-main__button-list3.png": 19399,
	"./visual-main__button-list4.png": 39784,
	"./visual-main__wrap.png": 54216
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77887;